const message = "https module is not available in the browser build";

function notImplemented(fn) {
  return function notImplementedWrapper() {
    throw new Error(`${fn}: ${message}`);
  };
}

module.exports = {
  request: notImplemented("https.request"),
  get: notImplemented("https.get"),
  Agent: notImplemented("https.Agent"),
};
